'use client'

import { LAYOUT_TEST_IDS } from '@common/common-test-ids.const'

import { CreateProjectDialogContainer } from './CreateProjectDialogContainer'
import { ProjectInviteDialogContainer } from './ProjectInviteDialogContainer'
import { WorkspaceInviteDialogContainer } from './WorkspaceInviteDialogContainer'

export function LayoutDialogHost() {
  return (
    <div data-testid={LAYOUT_TEST_IDS.layoutDialogHost} style={{ display: 'contents' }}>
      <CreateProjectDialogContainer />
      <ProjectInviteDialogContainer />
      <WorkspaceInviteDialogContainer />
    </div>
  )
}
